import { Component, Input, Output, EventEmitter } from '@angular/core';
interface SlickType {
  label: string;
  value: string;
}
@Component({
  selector: 'app-add-slick-sidebar',
  templateUrl: './add-slick-sidebar.component.html',
  styleUrls: ['./add-slick-sidebar.component.scss']
})
export class AddSlickSidebarComponent {
  // ---------- Inputs -----------
  @Input() invoiceSelected!: boolean;
  @Input() erroTamanhoImagem!: boolean;
  @Input() erroTipoImagem!: boolean;
  @Input() displaySidebar!: boolean;
  @Input() slickTypes!: SlickType[];
  @Input() valSelect1Video!: any;
  @Input() landscapeOptions!: any[];
  @Input() typeLive!: boolean;
  @Input() videoPreviewUrl!: string | null;
  @Input() uploadProgressVideo!: number;
  @Input() uploadProgress!: number;
  @Input() imageSelected!: boolean;
  @Input() imagePreviewUrl!: string | null;
  @Input() showImageDeleteButton!: boolean;
  @Input() hasError1!: boolean;
  @Input() hasError2!: boolean;
  @Input() hasError3!: boolean;
  @Input() hasSizeVideoError!: boolean;
  @Input() hasTypeVideoError!: boolean;
  @Input() selectedTags!: string[];
  @Input() tagsString!: string;
  @Input() publicarAgora!: boolean;
  @Input() dataSelecionada!: Date;
  @Input() minDate!: Date;
  @Input() disabledDates!: Date[];
  @Input() hasErrorCalendar!: boolean;
  @Input() loadingBtn!: boolean;
  @Input() uploadOn!: boolean;
  @Input() slickTitle!: string;
  @Input() slickDesc!: string;
  @Input() selectedSlickType!: SlickType;

  // --------- Outputs ---------
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<void>();
  @Output() onInputChange = new EventEmitter<void>();
  @Output() onTypeChange = new EventEmitter<any>();
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() myUploadMethod = new EventEmitter<any>();
  @Output() startVideo = new EventEmitter<HTMLVideoElement>();
  @Output() resetVideo = new EventEmitter<HTMLVideoElement>();
  @Output() handleCanPlayThrough = new EventEmitter<void>();
  @Output() removeVideo = new EventEmitter<MouseEvent>();
  @Output() onImageSelect = new EventEmitter<any>();
  @Output() myImageUploadMethod = new EventEmitter<any>();
  @Output() removeImage = new EventEmitter<MouseEvent>();
  @Output() updateTagsString = new EventEmitter<void>();
  @Output() simular = new EventEmitter<void>();
  @Output() onDateChange = new EventEmitter<Date>();

  
  
}
